import { render, staticRenderFns } from "./UpdateCliente.vue?vue&type=template&id=7371d26f&"
import script from "./UpdateCliente.vue?vue&type=script&lang=js&"
export * from "./UpdateCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports